/* https://simplesinovacao.com */
/* Developed by Guilherme: https://guilhermerocha.dev.br/ */

function handleSubMenuLinks(){
	const iconChevronSpan = document.createElement("span");
	iconChevronSpan.classList.add("icon-chevron-menu");
	iconChevronSpan.innerHTML = `<i class="fa fa-chevron-right" aria-hidden="true"></i>`;
	
	const headerDrawer = document.querySelector('header-drawer .menu-drawer__navigation');
	headerDrawer.querySelectorAll('li.gm-has-submenu>a').forEach(item => {
		item.append(iconChevronSpan.cloneNode(true));
	})

  if(window.screen.availWidth > 1024 && window.screen.availWidth < 1366){
    document.querySelectorAll('li.gm-has-submenu').forEach(li => {
      li.addEventListener('mouseover', (e) => {
          e.preventDefault();
          e.stopPropagation();
      })

      li.addEventListener('click', (e) => {
          li.classList.toggle('gm-active');
      })
    })
  }
}

function handleMapsBtn(){
	document.querySelector('#iframe-maps-button')?.addEventListener('click', () => {
		document.querySelector('#iframe-google-maps')?.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	})
}

$(document).ready(() => {
	handleMapsBtn();
})

function generateLinkWhatsApp(phoneNumber, message) {
  const numeroLimpo = phoneNumber.replace(/\D/g, '');
  
  const numeroCompleto = numeroLimpo.startsWith('55') ? numeroLimpo : '55' + numeroLimpo;
  
  const mensagemCodificada = encodeURIComponent(message);
  
  return `https://wa.me/${numeroCompleto}?text=${mensagemCodificada}`;
}

const whatsAction = document.querySelector('#whatsapp-action');

function handleWhatsClick() {
	if(whatsAction.querySelector('#rd-form')){
		whatsAction.querySelector('.whats-btn').addEventListener('click', (e) => {
			e.preventDefault();
			whatsAction.classList.add('open-form');
		})
		
		whatsAction.querySelector('#rd-form button.close').addEventListener('click', () => {
			whatsAction.classList.remove('open-form');
		})

		document.querySelector("form#conversion-form-nome-e-mail-e-telefone")?.addEventListener("submit", () => {
			const whatsTxt = `Olá! Preciso de uma informação, pode me ajudar?`;
			const phoneNumber = '5521974518940';
			const whatsLink = generateLinkWhatsApp(phoneNumber, whatsTxt);
			window.open(whatsLink, '_blank');
			whatsAction.classList.remove('open-form');
		})
	}
}

function customizeShippingBlock(){
	const shippingBlock = document.querySelector('#seu-carrinho-de-compras #MainContent .oct-calculator-form-container');
	
	const cartFooter = document.querySelector('#seu-carrinho-de-compras #MainContent .cart__footer');
	
	if(shippingBlock && cartFooter){
		cartFooter.insertAdjacentElement('beforebegin', document.querySelector(`section:has(.oct-calculator-form-container)`));
		
		if(window.screen.availWidth > 1024){
			shippingBlock.parentElement.classList.add("page-width");
		}
	}
}

function createSlider(){
	const swiperDoubleBannersWithCarouselMobile = new Swiper('.double-banners .swiper.enable-carousel-mobile', {
	    slidesPerView: 1,
	    spaceBetween: 0,
	    breakpoints: {
	        1024: {
	          slidesPerView: 2,
	          spaceBetween: 24,
	        }
	    },
	});
	
	const swiperDoubleBanners = new Swiper('.double-banners .swiper:not(.enable-carousel-mobile)', {
	    slidesPerView: 2,
	    direction: "vertical",
	    spaceBetween: 0,
	    allowTouchMove: false,
	    breakpoints: {
	        1024: {
				direction: "horizontal",
				spaceBetween: 30,
	        }
	    },
	});

	const productThumbs = new Swiper('.thumbnail-slider .swiper', {
		slidesPerView: 3.8,
		spaceBetween: 11,
		breakpoints: {
			1024: {
				slidesPerView: 4.8,
				spaceBetween: 14,
			}
		},
		navigation: {
			nextEl: '.slider-button--next',
			prevEl: '.slider-button--prev'
		}
	})
}

function handleNewsletterSubmit(){
	const newsletterTitle = document.querySelector('#newsletter .rd-text');
	const newsletterForm = document.querySelector("#conversion-form-newsletter-e-commerce");
	newsletterTitle?.prepend(document.querySelector('.header__heading-logo').cloneNode(true));

	newsletterForm?.addEventListener("submit", () => {
		setTimeout(() => {
			newsletterForm.reset();
		}, 300)
	})
	
}

window.addEventListener("load", () => {
	handleWhatsClick();
	customizeShippingBlock();
	createSlider();
	handleNewsletterSubmit();
	
	(function() {
		'use strict';
		var oldXHR, stateChangeHandler, prop;
		
		oldXHR = window.XMLHttpRequest;
		
		stateChangeHandler = function (evt) {
			switch (this.readyState) {
			  case oldXHR.OPENED:
			    //console.log('Request was made', this, evt);
			    break;
			  case oldXHR.DONE:
			      //console.log(this);
				  /*
			      if(this._url.indexOf('https://cta-redirect.rdstation.com/v2/conversions') !== -1){
			      	const whatsTxt = `Olá! Preciso de uma informação, pode me ajudar?`;
			      	const phoneNumber = '5521974518940';
			      	const whatsLink = generateLinkWhatsApp(phoneNumber, whatsTxt);
			      	window.open(whatsLink, '_blank');
			      	whatsAction.classList.remove('open-form');
			      }
					*/
			    break;
			}
		};
		
		function newXHR() {
			var xhr = new oldXHR();
			xhr.addEventListener('readystatechange', stateChangeHandler);
			return xhr;
		}
		
		// Copy original states and toString
		for (prop in oldXHR)
			newXHR[prop] = oldXHR[prop];
		
		window.XMLHttpRequest = newXHR;
	})();
})


/* NOVO LAYOUT */
async function copyTextToClipboard(text) {
	try {
		await navigator.clipboard.writeText(text);
		
		return true;
	} catch (err) {
		console.error('Failed to copy text: ', err);
	}
}

;(function btnCouponFunction(){
	const btnCoupon = document.querySelectorAll('.copy-coupon');

	btnCoupon.forEach(btn => {
		btn.addEventListener("click", (e) => {
			e.preventDefault();
			const p = btn.querySelector("p");
			const contentToCopy = p.textContent;
			const resp = copyTextToClipboard(contentToCopy);
			
			if(resp){
				p.textContent = "Cupom copiado ✅️";
				btn.classList.add("copied");
				
				setTimeout(function() {
					p.textContent = contentToCopy;
					btn.classList.remove("copied");
				}, 4000);
			}
		})
	})
})()

;(function handleHeaderContent(){
	const screenSize = window.screen.availWidth;
	
	const headerMenu = document.querySelector('.header__inline-menu');
	const searchContent = document.querySelector('predictive-search');
	const topoMenu = document.querySelector('header .topo-menu');
	const headerSearch = document.querySelector('header .header__search');
	const leftMenuMobile = document.querySelector('.left-menu-mobile');
	
	if(screenSize > 1024){
		if(headerMenu){
			headerMenu.classList.add("bottom-header", "hidden-mobile", "hidden-tablet");
			topoMenu?.append(headerMenu);
		}
		
		if(searchContent){
			topoMenu?.querySelector(".row .header__heading, .row .header__heading-link")?.insertAdjacentElement('afterend', searchContent);
		}	
	} else{
		if(headerSearch){
			leftMenuMobile?.append(headerSearch);
		}
	}
})()

;(function createSliders(){
	const swiperCollections = new Swiper('.support-block-custom .swiper', {
	    slidesPerView: 1,
	    spaceBetween: 8,
		autoplaySpeed: 5,
		autoplay: true,
	    breakpoints: {
	        768: {
	            slidesPerView: 2,
	            spaceBetween: 30,
	        },
	        1025: {
	            slidesPerView: 4,
	            spaceBetween: 30,
				autoplay: false
	        }
	    },
	});
	
	$('.mobile-toogles li:has(ul) span').on('click', function(){
        $(this).toggleClass("open");
        $(this).parent().children('ul').stop().slideToggle(400);
    });
})()

function createRecommendedSlide(){
	const recommendedProducts = new Swiper('product-recommendations .swiper', {
		slidesPerView: 2,
		spaceBetween: 8,
		autoplaySpeed: 5,
		autoplay: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true
		},
		breakpoints: {
			1025: {
				slidesPerView: 4,
				spaceBetween: 30,
			}
		},
	})

	document.querySelector('product-recommendations').classList.add("loaded");
}

;(function handleFooterContent(){
	const workTimeContent = document.querySelector('.footer-block.work-time');
	const footerMobileContent = document.querySelector('#mobile-footer-content');

	if(workTimeContent){
		footerMobileContent?.querySelector('.mobile-toogles')?.insertAdjacentElement('beforebegin', workTimeContent.cloneNode(true));
	}
})()

;(function handleItems(){
	const brandInfo = document.querySelector('.brand-info');
	
	if(window.screen.availWidth <= 1024 && brandInfo){
		brandInfo.querySelector('.image-with-text__media-item').insertAdjacentElement('beforebegin', brandInfo.querySelector('.image-with-text__heading'));
	}
	
	const newsletterContainer = document.querySelector('#newsletter');
	
	const newImgSrc = 'https://cdn.shopify.com/s/files/1/0604/3939/6429/files/logo-newsletter.png?v=1774810160';

  if(newsletterContainer){
		let timer = setInterval(() => {
      const rdColumn = newsletterContainer.querySelector('.bricks--column.rd-column');
			let img = newsletterContainer.querySelector("img");

			if(rdColumn){
        if(!img){
          img = document.createElement("img");
          img.classList.add("header__heading-logo");
          img.setAttribute("alt", "Shopping da Multidão");
          rdColumn.prepend(img);
        }

				img.setAttribute('src', newImgSrc);
				img.setAttribute('srcset', newImgSrc);
				
				const newsletterTitle = img.parentElement.querySelector('h2');
				newsletterTitle.textContent = 'Inscreva-se e fique por dentro de lançamentos, promoções e muito mais em primeira mão!';
				
				const row = document.createElement("div");
				row.classList.add("bricks--row", "rd-row");
				
				const colImg = document.createElement("div");
				colImg.classList.add("bricks--column", "rd-column");
				const colContent = document.createElement("div");
				colContent.classList.add("bricks--column", "rd-column"); 
				
				colImg.append(img);
				colContent.append(newsletterTitle);
				colContent.append(newsletterContainer.querySelector(".bricks-form.rd-form"));
				
				row.append(colImg);
				row.append(colContent);
				
				newsletterContainer.querySelectorAll('.rd-section .rd-row').forEach(oldRow => oldRow.remove());
				newsletterContainer.querySelector('.rd-section').append(row);
				
				if(window.screen.availWidth <= 1024){
					const newButton = document.createElement("button");
					newButton.textContent = "QUERO ME INSCREVER";
					newButton.classList.add("open-form-button");
					
					newButton.addEventListener("click", (e) => {
						e.preventDefault();
						colContent.classList.add('open-form');
					})
					
					colContent.prepend(newButton);
				}
	
				clearInterval(timer);
			}
		}, 100);
	}
})()

;(function(ns, fetch) {
      if (typeof fetch !== 'function') return;
    
      ns.fetch = function() {
        var out = fetch.apply(this, arguments);
        
        // side-effect
        out.then(({ ok }) => {
            //console.log('Requisição carregada', ok);

			if(arguments[0]?.indexOf('/recommendations/products?') !== -1 && document.querySelector('.main-product-template')){
				setTimeout(createRecommendedSlide, 1000)
			}
        });
        
        return out;
      }
    
    }(window, window.fetch))

// Página de coleção

// BUSCA DE PRODUTOS NA PÁGINA DE COLEÇÃO - OK

function normalizeText(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/[áà]/g, 'a')
    .replace(/[ãâ]/g, 'a')
    .replace(/[éè]/g, 'e')
    .replace(/[êë]/g, 'e')
    .replace(/[íì]/g, 'i')
    .replace(/[óò]/g, 'o')
    .replace(/[ôõ]/g, 'o')
    .replace(/[úù]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[ñ]/g, 'n');
}

function showSubCollections() {
  const collectionUrl = document
    .querySelector('.collection-link-breadcrumbs')
    ?.href?.split('?')[0];
  const subCollections = [];

  document
    .querySelectorAll('.menu-drawer__menu li.gm-item.gm-level-0')
    .forEach(li => {
      const liUrl = li.querySelector('a')?.href.split('?')[0];

      if (collectionUrl && liUrl === collectionUrl) {
        li.querySelectorAll(
          '.gm-submenu li.gm-item:not(.gm-heading):not(.gm-has-submenu) a:not([aria-label="Ver Tudo"])',
        ).forEach(sub => {
          if (sub.title !== 'Ver Tudo' && sub.getAttribute('aria-label') !== 'Ver tudo')
            subCollections.push(sub.cloneNode(true));
        });
      }
    });

  if (!subCollections.length) return;

  const divSubcollections = document.createElement('div');
  divSubcollections.classList.add('subcollections-container');
  divSubcollections.innerHTML = `
  <div class="subcategories-title">
	<strong>
	  <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M24.75 3.75H8.25M5.25 3.75H0.75M24.75 18.75H8.25M5.25 18.75H0.75M17.25 11.25H0.75M24.75 11.25H20.25M6.75 0.75C7.14782 0.75 7.52936 0.908036 7.81066 1.18934C8.09196 1.47064 8.25 1.85218 8.25 2.25V5.25C8.25 5.64782 8.09196 6.02936 7.81066 6.31066C7.52936 6.59196 7.14782 6.75 6.75 6.75C6.35218 6.75 5.97064 6.59196 5.68934 6.31066C5.40804 6.02936 5.25 5.64782 5.25 5.25V2.25C5.25 1.85218 5.40804 1.47064 5.68934 1.18934C5.97064 0.908036 6.35218 0.75 6.75 0.75ZM6.75 15.75C7.14782 15.75 7.52936 15.908 7.81066 16.1893C8.09196 16.4706 8.25 16.8522 8.25 17.25V20.25C8.25 20.6478 8.09196 21.0294 7.81066 21.3107C7.52936 21.592 7.14782 21.75 6.75 21.75C6.35218 21.75 5.97064 21.592 5.68934 21.3107C5.40804 21.0294 5.25 20.6478 5.25 20.25V17.25C5.25 16.8522 5.40804 16.4706 5.68934 16.1893C5.97064 15.908 6.35218 15.75 6.75 15.75ZM18.75 8.25C19.1478 8.25 19.5294 8.40804 19.8107 8.68934C20.092 8.97064 20.25 9.35218 20.25 9.75V12.75C20.25 13.1478 20.092 13.5294 19.8107 13.8107C19.5294 14.092 19.1478 14.25 18.75 14.25C18.3522 14.25 17.9706 14.092 17.6893 13.8107C17.408 13.5294 17.25 13.1478 17.25 12.75V9.75C17.25 9.35218 17.408 8.97064 17.6893 8.68934C17.9706 8.40804 18.3522 8.25 18.75 8.25Z" stroke="#03458A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	
		Subcategorias
	  </strong>
  </div>
  <div class="swiper">
	<ul class="swiper-wrapper"></ul>
  </div>
  `;

  subCollections.forEach(sub => {
    const li = document.createElement('li');
    li.classList.add("swiper-slide");

    // Ao clicar, navega para a subcoleção preservando filtros e busca atuais
    sub.addEventListener('click', e => {
      e.preventDefault();
      // Método 1:
      redirectSubCollection(sub);

      // Método 2:
    });
    
    if (sub.title !== 'Ver tudo' && sub.getAttribute('aria-label') !== 'Ver tudo') {
      li.append(sub);
      divSubcollections.querySelector('ul').append(li);
    }
  });

  document.querySelector('#subcategories-searchform')?.prepend(divSubcollections);
}

function redirectSubCollection(subCollectionElement) {
  const subUrl = new URL(
    subCollectionElement.href.split('?')[0],
    window.location.origin,
  );
  const currentParams = new URLSearchParams(window.location.search);
  currentParams.forEach((value, key) => {
    subUrl.searchParams.set(key, value);
  });
  window.location.href = subUrl.toString();
}

function createSubCollectionsSwiper(){
	const swiperSubCollections = new Swiper('#subcategories-searchform .subcollections-container .swiper', {
	    slidesPerView: 3.1,
	    spaceBetween: 10,
	    breakpoints: {
	        1025: {
	          slidesPerView: 4,
	          spaceBetween: 20,
	        },
	        1366: {
	          slidesPerView: 7,
	        }
	    },
	});
}

function insertSearchFields() {
  const inputArea = document.createElement('div');
  inputArea.classList.add("custom-search");
  inputArea.innerHTML = `
	<input type="text" class="search-input" placeholder="Buscar produtos...">
  <button class="search-btn">
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.9398 18.5624L13.4475 12.0699C14.4549 10.7674 14.9998 9.17494 14.9998 7.49996C14.9998 5.49497 14.2174 3.61498 12.8025 2.19749C11.3874 0.779989 9.50244 0 7.49996 0C5.49746 0 3.61248 0.782498 2.19749 2.19749C0.779989 3.61248 0 5.49497 0 7.49996C0 9.5024 0.782497 11.3874 2.19749 12.8025C3.61248 14.2199 5.49497 14.9998 7.49996 14.9998C9.17494 14.9998 10.765 14.4549 12.0674 13.4499L18.5599 19.9398C18.579 19.9589 18.6015 19.974 18.6264 19.9844C18.6513 19.9946 18.6779 20 18.7049 20C18.7318 20 18.7585 19.9946 18.7834 19.9844C18.8082 19.974 18.8309 19.9589 18.8499 19.9398L19.9398 18.8524C19.9589 18.8333 19.974 18.8108 19.9844 18.7858C19.9946 18.761 20 18.7343 20 18.7073C20 18.6805 19.9946 18.6538 19.9844 18.6289C19.974 18.604 19.9589 18.5814 19.9398 18.5624ZM11.4599 11.4599C10.3999 12.5174 8.99494 13.0999 7.49996 13.0999C6.00497 13.0999 4.59997 12.5174 3.53997 11.4599C2.48248 10.3999 1.89999 8.99494 1.89999 7.49996C1.89999 6.00497 2.48248 4.59748 3.53997 3.53997C4.59997 2.48248 6.00497 1.89999 7.49996 1.89999C8.99494 1.89999 10.4025 2.47998 11.4599 3.53997C12.5174 4.59997 13.0999 6.00497 13.0999 7.49996C13.0999 8.99494 12.5174 10.4025 11.4599 11.4599Z" fill="#03428D"/>
</svg>
</button>
		`;

  document.querySelector('#subcategories-searchform')?.append(inputArea);
}

function initCollectionSearch() {
  const input = document.querySelector('.search-input');
  const button = document.querySelector('.search-btn');

  if (!input || !button) return;

  // Pré-preenche o campo caso 'q' já esteja na URL (ex: ao voltar com histórico)
  const initialParams = new URLSearchParams(window.location.search);
  if (initialParams.get('q')) {
    input.value = initialParams.get('q');
  }

  async function searchProducts() {
    const query = input.value.trim();

    // Preserva todos os parâmetros atuais (filter.*, sort_by, etc.) e atualiza 'q'
    const searchParams = new URLSearchParams(window.location.search);
    if (query) {
      searchParams.set('q', query);
    } else {
      searchParams.delete('q');
    }
    searchParams.delete('page');
    const baseQueryString = searchParams.toString();

    const parser = new DOMParser();

    async function fetchPage(page) {
      const params = new URLSearchParams(baseQueryString);
      if (page > 1) params.set('page', page);
      const url = `${window.location.pathname}?${params.toString()}&sections=main-collection-product-grid`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
      const data = await res.json();
      return parser.parseFromString(
        data['main-collection-product-grid'],
        'text/html',
      );
    }

    button.disabled = true;
    const searchSvg = button.querySelector("svg");
    button.textContent = 'Buscando...';

    try {
      // Página 1: usada como template base e para estimar o total de produtos
      const doc1 = await fetchPage(1);

      // Sem query: apenas atualiza com a página 1 e encerra
      if (!query) {
        const newGrid = doc1.querySelector('#ProductGridContainer');
        const currentGrid = document.querySelector('#ProductGridContainer');
        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
          currentGrid.querySelector('.custom-search-empty')?.remove();
        }
        const newBrowserUrl = baseQueryString
          ? `${window.location.pathname}?${baseQueryString}`
          : window.location.pathname;
        window.history.pushState({}, '', newBrowserUrl);
        return;
      }

      const allItems = Array.from(
        doc1.querySelectorAll('#product-grid .grid__item'),
      );
      const productsPerPage = allItems.length > 0 ? allItems.length : 16;

      // data-page-items-count reflete collection.products_count com filtros aplicados.
      // Disponível quando pagination != 'numbers'.
      const totalCountAttr = doc1.querySelector('.custom-page-progress-bar')
        ?.dataset.pageItemsCount;
      const totalCount = totalCountAttr ? parseInt(totalCountAttr, 10) : NaN;

      if (!isNaN(totalCount) && totalCount > productsPerPage) {
        // Total de páginas conhecido: busca todas em paralelo
        const totalPages = Math.min(
          Math.ceil(totalCount / productsPerPage),
          50,
        );
        const pagePromises = [];
        for (let p = 2; p <= totalPages; p++) {
          pagePromises.push(
            fetchPage(p).then(doc =>
              Array.from(doc.querySelectorAll('#product-grid .grid__item')),
            ),
          );
        }
        const pages = await Promise.all(pagePromises);
        pages.forEach(items => allItems.push(...items));
      } else if (isNaN(totalCount)) {
        // Fallback (pagination = 'numbers'): busca em lotes de 5 até receber página vazia
        let page = 2;
        while (page <= 50) {
          const batch = [];
          for (let i = 0; i < 5 && page <= 50; i++, page++) {
            batch.push(
              fetchPage(page).then(doc =>
                Array.from(doc.querySelectorAll('#product-grid .grid__item')),
              ),
            );
          }
          const results = await Promise.all(batch);
          const batchItems = results.flat();
          allItems.push(...batchItems);
          // Para quando a última página do lote vier vazia
          if (results[results.length - 1].length === 0) break;
        }
      }

      // Filtra por nome em TODOS os produtos coletados de todas as páginas
      const normalizedQuery = normalizeText(query);
      const matchingItems = allItems.filter(item => {
        const title = item.querySelector('.card__heading')?.textContent ?? '';
        return normalizeText(title).includes(normalizedQuery);
      });

      // Atualiza a grid com os resultados
      const newGrid = doc1.querySelector('#ProductGridContainer');
      const currentGrid = document.querySelector('#ProductGridContainer');

      if (newGrid && currentGrid) {
        currentGrid.innerHTML = newGrid.innerHTML;

        const productGrid = currentGrid.querySelector('#product-grid');
        if (productGrid) {
          productGrid.innerHTML = '';
          // Remove controles de paginação — não se aplicam ao modo de busca
          currentGrid.querySelector('#AjaxinatePagination')?.remove();
          currentGrid
            .querySelectorAll('.pagination-wrapper, nav[role="navigation"]')
            .forEach(el => el.remove());

          matchingItems.forEach(item => {
            item.style.display = '';
            productGrid.appendChild(item);
          });
        }

        const countEl = currentGrid.querySelector('.ProductCountDesktop');
        if (countEl) {
          countEl.textContent =
            matchingItems.length === 0
              ? 'Nenhum produto encontrado'
              : `${matchingItems.length} produto${matchingItems.length > 1 ? 's' : ''} encontrado${matchingItems.length > 1 ? 's' : ''}`;
        }

        currentGrid.querySelector('.custom-search-empty')?.remove();
        if (matchingItems.length === 0) {
          const emptyMsg = document.createElement('p');
          emptyMsg.classList.add('custom-search-empty');
          emptyMsg.textContent = `Nenhum produto encontrado para "${query}"`;
          productGrid?.after(emptyMsg);
        }
      }

      // Atualiza a URL do navegador sem recarregar a página
      const newBrowserUrl = baseQueryString
        ? `${window.location.pathname}?${baseQueryString}`
        : window.location.pathname;
      window.history.pushState({}, '', newBrowserUrl);
    } catch (err) {
      console.error('Erro na busca:', err);
    } finally {
      button.disabled = false;
      button.textContent = '';
      button.append(searchSvg.cloneNode(true));
    }
  }

  button.addEventListener('click', searchProducts);

  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      searchProducts();
    }
  });
}

function configCollectionMobileLayout(){
	const sortDrawerMobile = document.querySelector('menu-drawer.mobile-facets__wrapper');
	
	const subCollectionsContainer = document.querySelector('.subcollections-container .subcategories-title');
	
	if(subCollectionsContainer && sortDrawerMobile){
		subCollectionsContainer.append(sortDrawerMobile);
	}
}

(function configSearchFacetsMobileLayout(){
	const sortDrawerMobile = document.querySelector('.is-search menu-drawer.mobile-facets__wrapper');
	
	const keyWords = document.querySelector('.is-search .key-words-tags');
	
	if(keyWords && sortDrawerMobile){
		keyWords.insertAdjacentElement('afterend', sortDrawerMobile);
	}
})();

window.addEventListener('load', () => {
  if (typeof __st !== 'undefined' && __st.p === 'collection') {
    showSubCollections();
    createSubCollectionsSwiper();
    insertSearchFields();
    initCollectionSearch();
    configCollectionMobileLayout();
  }
});

// Consultando estado

async function buscarEstadoPorCEP(cep) {
  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
  const data = await response.json();

  if (data.erro) {
    throw new Error("CEP não encontrado");
  }

  return {
    uf: data.uf,
    estado: data.estado
  };
}

function populateOptions(){
	const allStates = document.querySelectorAll('#address_province option');
	const productPageSelect = document.querySelector('.oct-calculator-field-province');
	console.log(productPageSelect)
	if(productPageSelect){
		allStates.forEach((option, index) => {
			productPageSelect.append(option.cloneNode(true));
		})
	}
}

function listenCepChanges(){
	document.querySelector('#Shipping-Wrapper summary')?.click();

	document.querySelector('#address_zip')?.addEventListener('input', (e) => {
		const cepCart = e.target.value.replaceAll('-', '');

		if(cepCart.length === 8){
			buscarEstadoPorCEP(cepCart)
			.then((value) => {
				if(value.estado){
					document.querySelector('#address_province').value = value.estado;
				}
			})
			.catch(console.error);
		}
	})

	/* tentando fazer o mesmo na página de produto
	const notFoundResult = document.createElement('div');
	notFoundResult.classList.add('oct-calculator-result');
	notFoundResult.innerHTML = `
		<div class="oct-calculator-results-not-found">Nenhum método de envio disponível foi encontrado para o endereço fornecido. Por favor, altere o endereço de entrega e tente novamente.</div>
	`;

	const inputZipCodeProdutct = document.querySelector('.main-product-template .oct-calculator-field-zip');
	
	populateOptions();

	if(inputZipCodeProdutct){
		inputZipCodeProdutct.value = '';
	}

	inputZipCodeProdutct?.addEventListener('input', (e) => {
		const cepProductPage = e.target.value.replaceAll('-', '');

		if(notFoundResult){
			notFoundResult.remove();
		}

		if(cepProductPage.length === 8){
			buscarEstadoPorCEP(cepProductPage)
			.then((value) => {
				const {uf, estado} = value;
				if(uf){
					const hasUfReturned = document.querySelector(`.oct-calculator-field-province option[value="${uf}"]`);
					
					if(hasUfReturned){
						document.querySelector('.oct-calculator-field-province').value = uf;
						hasUfReturned.click();
					} else{
						console.log(estado);
						console.log(document.querySelector('.oct-calculator-field-province'))
						document.querySelector('.oct-calculator-field-province').value = estado;
						//document.querySelector('.oct-calculator-result-outro')?.insertAdjacentElement('afterend', notFoundResult);
					}
					
				} else{
					//document.querySelector('.oct-calculator-result-outro')?.insertAdjacentElement('afterend', notFoundResult);
				}
			})
			.catch(console.error);
		}
	})
	*/
}

// Cálculo do frete na página de produto
function handleZipTaxesProduct(){
	const inputZipCodeProdutct = document.querySelector('.main-product-template .oct-calculator-field-zip');

	if(inputZipCodeProdutct){
		inputZipCodeProdutct.value = '';
	}

	inputZipCodeProdutct?.addEventListener('input', (e) => {
		const cepProductPage = e.target.value.replaceAll('-', '');

		if(cepProductPage.length === 8){
			buscarEstadoPorCEP(cepProductPage)
			.then((value) => {
				const {uf, estado} = value;
				if(uf){
					const hasUfReturned = document.querySelector(`.oct-calculator-field-province option[value="${uf}"]`);
					
					if(hasUfReturned){
						handleZipCalculatorButton(false);
					} else{
						handleZipCalculatorButton(true, 'Não enviamos para este endereço');
					}
					
				} else{
					handleZipCalculatorButton(true, 'Não foi possível encontrar o endereço');
				}
			})
			.catch(console.error);
		} else{
			handleZipCalculatorButton(true, 'Digite um CEP válido');
		}
	})
}

function detectChangesZipCalculatorContainer(){
	const zipContainer = document.querySelector(".oct-calculator-form-container");
		
	MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

	var observer = new MutationObserver(function(mutations, observer) {
		const inputZipCodeProdutct = document.querySelector('.main-product-template .oct-calculator-field-zip');

		if(inputZipCodeProdutct){
			setFirstProvince();
			handleZipTaxesProduct();
		}
	});
	
	if(zipContainer){
		observer.observe(zipContainer, {
			attributes: false,
			characterData: false,
			subtree: false,
			attributeOldValue: false,
			childList: true,
			characterDataOldValue: false
		});
	}
}

function handleZipCalculatorButton(disable, text){
	const btnCalculate = document.querySelector('.oct-calculator-button');
	
	if(disable){
		btnCalculate.setAttribute('disabled', 'disabled');
		btnCalculate.setAttribute('title', text);
		
		btnCalculate.addEventListener('click', (e) => {
			e.preventDefault();
		});
		
		const divError = document.createElement('div');
		divError.classList.add('zip-error');
		divError.innerHTML = `
			<p>${text}.</p>
		`;
		if(document.querySelector('.oct-calculator-form-container>.oct-calculator-form-container .zip-error')){
			document.querySelector('.oct-calculator-form-container>.oct-calculator-form-container .zip-error p').textContent = text+'.';
		} else{
			document.querySelector('.oct-calculator-form-container>.oct-calculator-form-container').append(divError);
		}
		
	} else{
		btnCalculate.removeAttribute('disabled');
		btnCalculate.removeAttribute('title');
		document.querySelector('.oct-calculator-form-container>.oct-calculator-form-container .zip-error')?.remove();
	}
}

function setFirstProvince() {
  const select = document.querySelector('.oct-calculator-field-province');
  if (!select) return;

  const options = select.querySelectorAll('option');

  if (options.length > 1) {
    select.selectedIndex = 1; // pega a primeira opção válida (ignorando "Região")

    // dispara change (IMPORTANTE para apps)
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

window.addEventListener('load', () => {
	listenCepChanges();
	handleZipTaxesProduct();
	
	setTimeout(() => {
		setFirstProvince();
		detectChangesZipCalculatorContainer();
	}, 500);
})

/* FINAL NOVO LAYOUT */